var map = {
	"./AI": [
		7112,
		9,
		112
	],
	"./AI/": [
		7112,
		9,
		112
	],
	"./AI/index": [
		7112,
		9,
		112
	],
	"./AI/index.module.scss": [
		523,
		9,
		523
	],
	"./AI/index.tsx": [
		7112,
		9,
		112
	],
	"./BookList": [
		2496,
		9,
		496
	],
	"./BookList/": [
		2496,
		9,
		496
	],
	"./BookList/index": [
		2496,
		9,
		496
	],
	"./BookList/index.module.scss": [
		3454,
		9,
		454
	],
	"./BookList/index.tsx": [
		2496,
		9,
		496
	],
	"./Chat": [
		6218,
		9,
		657,
		424,
		218
	],
	"./Chat/": [
		6218,
		9,
		657,
		424,
		218
	],
	"./Chat/index": [
		6218,
		9,
		657,
		424,
		218
	],
	"./Chat/index.module.scss": [
		1195,
		9,
		195
	],
	"./Chat/index.tsx": [
		6218,
		9,
		657,
		424,
		218
	],
	"./Daily": [
		3571,
		9,
		571
	],
	"./Daily/": [
		3571,
		9,
		571
	],
	"./Daily/index": [
		3571,
		9,
		571
	],
	"./Daily/index.module.scss": [
		7430,
		9,
		430
	],
	"./Daily/index.tsx": [
		3571,
		9,
		571
	],
	"./Games": [
		7531,
		9,
		531
	],
	"./Games/": [
		7531,
		9,
		531
	],
	"./Games/index": [
		7531,
		9,
		531
	],
	"./Games/index.tsx": [
		7531,
		9,
		531
	],
	"./Home": [
		1516,
		9,
		657,
		861,
		516
	],
	"./Home/": [
		1516,
		9,
		657,
		861,
		516
	],
	"./Home/ToolList": [
		1640,
		9,
		657,
		861,
		640
	],
	"./Home/ToolList/": [
		1640,
		9,
		657,
		861,
		640
	],
	"./Home/ToolList/index": [
		1640,
		9,
		657,
		861,
		640
	],
	"./Home/ToolList/index.module.scss": [
		9283,
		9,
		283
	],
	"./Home/ToolList/index.tsx": [
		1640,
		9,
		657,
		861,
		640
	],
	"./Home/index": [
		1516,
		9,
		657,
		861,
		516
	],
	"./Home/index.module.scss": [
		900,
		9,
		900
	],
	"./Home/index.tsx": [
		1516,
		9,
		657,
		861,
		516
	],
	"./Home/myPromise": [
		3780,
		9,
		780
	],
	"./Home/myPromise.js": [
		3780,
		9,
		780
	],
	"./News": [
		851,
		9,
		851
	],
	"./News/": [
		851,
		9,
		851
	],
	"./News/index": [
		851,
		9,
		851
	],
	"./News/index.module.scss": [
		8420,
		9,
		420
	],
	"./News/index.tsx": [
		851,
		9,
		851
	],
	"./Notes": [
		4689,
		9,
		689
	],
	"./Notes/": [
		4689,
		9,
		689
	],
	"./Notes/index": [
		4689,
		9,
		689
	],
	"./Notes/index.module.scss": [
		6634,
		9,
		634
	],
	"./Notes/index.tsx": [
		4689,
		9,
		689
	],
	"./Notes/noteList": [
		4487,
		9,
		487
	],
	"./Notes/noteList.ts": [
		4487,
		9,
		487
	],
	"./PersonalProfile": [
		9465,
		9,
		465
	],
	"./PersonalProfile/": [
		9465,
		9,
		465
	],
	"./PersonalProfile/index": [
		9465,
		9,
		465
	],
	"./PersonalProfile/index.module.scss": [
		6114,
		9,
		114
	],
	"./PersonalProfile/index.tsx": [
		9465,
		9,
		465
	],
	"./Prompt": [
		3612,
		9,
		612
	],
	"./Prompt/": [
		3612,
		9,
		612
	],
	"./Prompt/index": [
		3612,
		9,
		612
	],
	"./Prompt/index.tsx": [
		3612,
		9,
		612
	],
	"./ResourceDetail": [
		3417,
		9,
		417
	],
	"./ResourceDetail/": [
		3417,
		9,
		417
	],
	"./ResourceDetail/index": [
		3417,
		9,
		417
	],
	"./ResourceDetail/index.module.scss": [
		8154,
		9,
		154
	],
	"./ResourceDetail/index.tsx": [
		3417,
		9,
		417
	],
	"./Resources": [
		4105,
		9,
		105
	],
	"./Resources/": [
		4105,
		9,
		105
	],
	"./Resources/index": [
		4105,
		9,
		105
	],
	"./Resources/index.module.scss": [
		8914,
		9,
		914
	],
	"./Resources/index.tsx": [
		4105,
		9,
		105
	],
	"./SolarSystem": [
		7580,
		9,
		968,
		580
	],
	"./SolarSystem/": [
		7580,
		9,
		968,
		580
	],
	"./SolarSystem/index": [
		7580,
		9,
		968,
		580
	],
	"./SolarSystem/index.js": [
		7580,
		9,
		968,
		580
	],
	"./SolarSystem/t": [
		4020,
		7,
		20
	],
	"./SolarSystem/t.js": [
		4020,
		7,
		20
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 629;
module.exports = webpackAsyncContext;